/* ==========================================================================
   Joy loyalty — referral popup, the one line the theme adds
   Theme: Pippadu & Ceramide 2026

   The claim screen asks a referred friend for an email address and says nothing
   about why, which is the thing to fix for GDPR: the reason has to be next to
   the field, not on a policy page. The Joy app has no setting for this line, so
   the theme writes it.

   Where it goes
   -------------
   The card already renders an empty subtitle:

     <div>
       <h4 class="Avada-ReferralCard__Title">…</h4>
       <p  class="Avada-ReferralCard__Description"></p>   <- empty on this screen
     </div>

   PopupReferralReward passes no `subtitle`, so that paragraph is always empty
   here — exactly the slot this line wants, directly under the heading and above
   the field. The success screen fills the same paragraph with its own copy, so
   only an EMPTY one is ever written to. That single test is what keeps the note
   off the screen it does not belong on.

   Why an observer
   ---------------
   The card is a React root: it mounts late, and it re-renders when the claim
   turns into the success screen. Anything written into it has to be written
   again afterwards. Debounced with setTimeout rather than requestAnimationFrame
   — rAF is paused while the tab is not painting, which silently kills it.

   The text is put inside our own <span> rather than set as the paragraph's text.
   React created no text node in there (the value was undefined), so it has none
   to reconcile against, and a child element is the least likely thing for it to
   tidy away on the next pass.
   ========================================================================== */

(function () {
  'use strict';

  var NOTE = document.documentElement.getAttribute('data-joy-referral-note');
  if (!NOTE) return;

  var SLOT_SELECTOR = '.Avada-Referral__Popup .Avada-ReferralCard__Description';
  var NOTE_CLASS = 'joy-refpopup__note';

  function apply() {
    var slots = document.querySelectorAll(SLOT_SELECTOR);

    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];

      if (slot.querySelector('.' + NOTE_CLASS)) continue;
      /* Anything else already in there is the app's own copy — the success
         screen's "you got a coupon" line. Never write over it. */
      if (slot.firstChild) continue;

      var note = document.createElement('span');
      note.className = NOTE_CLASS;
      note.textContent = NOTE;
      slot.appendChild(note);
    }
  }

  function watch() {
    apply();

    var timer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(apply, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
